import React from "react";
import { Card, ListGroup, ListGroupItem } from "react-bootstrap";

const DownloadAdmitCard = () => {
  const studentData = {
    name: "John Doe",
    regNumber: "MBBS123456",
    course: "MBBS",
    examCenter: "AIIMS Patna",
    examDate: "20th August 2024",
    reportingTime: "9:00 AM",
  };

  return (
    <>
      <Card
        style={{
          width: "100%",
          margin: "20px",
          borderRadius: "10px",
          border: "1px solid #ccc",
        }}
      >
        <Card.Header
          className="bg-primary text-white"
          style={{ borderTopLeftRadius: "10px", borderTopRightRadius: "10px" }}
        >
          <h2>{studentData.course} Admit Card</h2>
        </Card.Header>
        <Card.Body>
          <Card.Title className="text-center">{studentData.name}</Card.Title>
          <ListGroup className="list-group-flush">
            <ListGroupItem>
              <strong>Registration Number:</strong> {studentData.regNumber}
            </ListGroupItem>
            <ListGroupItem>
              <strong>Course:</strong> {studentData.course}
            </ListGroupItem>
            <ListGroupItem>
              <strong>Examination Center:</strong> {studentData.examCenter}
            </ListGroupItem>
            <ListGroupItem>
              <strong>Examination Date:</strong> {studentData.examDate}
            </ListGroupItem>
            <ListGroupItem>
              <strong>Reporting Time:</strong> {studentData.reportingTime}
            </ListGroupItem>
          </ListGroup>
        </Card.Body>
        <Card.Footer
          className="text-muted"
          style={{
            borderBottomLeftRadius: "10px",
            borderBottomRightRadius: "10px",
          }}
        >
          Please bring this admit card along with a valid ID proof.
        </Card.Footer>
      </Card>
    </>
  );
};

export default DownloadAdmitCard;
